import { Injectable } from '@angular/core';
import { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { MapContentMapService } from './map-content-map.service';
import { MapService } from './map.service';

@Injectable({ providedIn: 'root' })
export class ConditionMapService extends MapContentMapService {
    override minZoom = 8;
    constructor(consoleLogService: ConsoleLogService, mapService: MapService) {
        super(consoleLogService, mapService);
        super.setSourceId('rideconditions');
    }

    override addSources(mapboxMap: MapboxMap): void {
        this.getLayerIds(this.mapService.getLayerIds(mapboxMap));
    }
}
